"use client";

import type { ReactNode } from "react";
import Flex from "@/shared/components/common/Flex";
import Skeleton from "@/shared/components/common/Skeleton";

export default function MobileBannerSkeleton() {
  return (
    <Flex
      className={
        "md:hidden w-full h-16 flex md:px-8 border-b bg-background border-border sticky overflow-hidden top-0 right-0 left-0 z-40 transition duration-200 easeInOutCirc"
      }
    >
      <Flex className="w-full justify-between items-center px-4">
        <Flex className="w-full gap-3 items-center">
          <Skeleton className="w-8 h-8 rounded-full" />
          <Flex className="flex-col gap-1 items-start h-full justify-center">
            <Skeleton className="w-32 h-4 rounded-full" />
            <Skeleton className="w-24 h-3" />
          </Flex>
        </Flex>
        <Skeleton className="min-w-10 min-h-10 rounded-full" />
      </Flex>
    </Flex>
  );
}
